(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yc-class-summary"] && !Shopify.designMode) return;
  try {
    function renderClassDates(root) {
    root.querySelectorAll('.yc-class-event[data-class-date]').forEach(card => {
      const date = new Date(card.dataset.classDate);
      if (Number.isNaN(date.getTime())) return;
      const timeZone = card.dataset.classZone || 'America/Vancouver';
      try {
        const options = {
          month: { month: 'long', year: 'numeric' },
          day: { day: 'numeric' },
          weekday: { weekday: 'long' },
          time: { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }
        };
        Object.entries(options).forEach(([key, value]) => {
          card.querySelector('[data-event-' + key + ']').textContent =
            window.YCClassTime.format(date, document.documentElement.lang || 'en-CA', value, timeZone);
        });
      } catch (_) {}
    });
  }
  renderClassDates(document);
  document.addEventListener('DOMContentLoaded', () => renderClassDates(document));
  document.addEventListener('shopify:section:load', event => renderClassDates(event.target));
  } catch(e) { console.error(e); }
})();

})();
